import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private activeRequests = 0;
  public isLoading = new BehaviorSubject<boolean>(false);

  /**
   * Increments the active request count and shows the loader.
   * Call this when starting an async operation.
   */
  public show(): void {
    this.activeRequests++;
    this.isLoading.next(true);
  }

  /**
   * Decrements the active request count and hides the loader only when all requests complete.
   * Call this when an async operation finishes.
   */
  public hide(): void {
    this.activeRequests = Math.max(0, this.activeRequests - 1);
    if (this.activeRequests === 0) {
      this.isLoading.next(false);
    }
  }
}
